<template>
    <div>
        <div class="tb-navbar">
            <div class="row">
                <div class="col-8 col-md-3">
                    <router-link to="/client">
                        <img class="tb-navbar__logo" src="@/assets/ca_logo.svg">
                    </router-link>
                </div>

                <div class="col-4 col-md-9">
                    <div class="tb-navbar__right">
                        <router-link to="/client/profile" class="tb-navbar__user">
                            <span class="inline-fa">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/></svg>
                            </span>
                        </router-link>

                        <a href="#" class="tb-navbar__dropdown-toggle"
                           @click.prevent="toggleDropdown()">
                            <span class="inline-fa">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z"/></svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <transition name="slide">
                <div class="tb-navbar__menu" v-if="is_dropdown">
                <span class="tb-navbar__menu-item" @click.prevent="hideDropdown()">
                    <router-link :to="'/client/events'">
                        Manage Events
                    </router-link>
                </span>

                    <span class="tb-navbar__menu-item tb-navbar__menu-item--right"
                          @click.prevent="hideDropdown()">
                    <a href="#" @click.prevent="logout()">
                        Log Out
                    </a>
                </span>
                </div>
            </transition>
        </div>

        <div class="py-5">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import {api} from "@/repository/repository.js";

export default {
    data: () => {
        return {
            is_dropdown: false
        }
    },

    computed: {
        user() {
            return this.$store.getters.user;
        }
    },

    methods: {
        hideDropdown() {
            console.log('x');
            this.is_dropdown = false;
        },

        toggleDropdown() {
            this.is_dropdown = !this.is_dropdown;
        },

        logout() {
            api.get('/logout')
                .then(response=>{
                    // console.log('logged out');
                    window.location = '/';
                    //
                });
        }
    }
}
</script>

<style lang="scss">

.logo {
    //max-width: 300px;
}
a.router-link-active {
    color: white!important;
}

.tb-dropdown-menu {

}
</style>

<!--<template>-->
<!--    <div>-->
<!--        <b-navbar toggleable="md" class="navbar">-->
<!--            <b-navbar-brand class="col-md-3">-->
<!--                <router-link to="/">-->
<!--                    <img class="logo" src="@/assets/ca_logo.svg">-->
<!--                </router-link>-->

<!--                &lt;!&ndash; clubsaway logo &ndash;&gt;-->
<!--            </b-navbar-brand>-->
<!--            <b-navbar-toggle target="nav_collapse"/>-->

<!--            <b-collapse is-nav id="nav_collapse">-->
<!--                <b-navbar-nav>-->
<!--                    <b-nav-item to="/client/events">-->
<!--                        Manage Events-->
<!--                    </b-nav-item>-->
<!--                </b-navbar-nav>-->

<!--                <b-navbar-nav class="ml-auto">-->
<!--                    <b-nav-item-dropdown right>-->
<!--                        <template slot="button-content">-->
<!--                            {{ user.name }}-->
<!--                        </template>-->

<!--                        <b-dropdown-item to="/client/profile">-->
<!--                            Your Profile-->
<!--                        </b-dropdown-item>-->

<!--                        <b-dropdown-item href="#" @click="logout()">-->
<!--                            Log Out-->
<!--                        </b-dropdown-item>-->
<!--                    </b-nav-item-dropdown>-->
<!--                </b-navbar-nav>-->
<!--            </b-collapse>-->
<!--        </b-navbar>-->


<!--        <div class="py-5 content-area">-->
<!--            <router-view></router-view>-->
<!--        </div>-->
<!--        <tb-footer></tb-footer>-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    import TbFooter from '@/views/Footer.vue';-->
<!--    import {api} from "@/repository/repository.js";-->
<!--    export default {-->
<!--        components: {-->
<!--            TbFooter-->
<!--        },-->
<!--        computed: {-->
<!--            user() {-->
<!--                return this.$store.getters.user;-->
<!--            }-->
<!--        },-->

<!--        methods: {-->
<!--            logout() {-->
<!--                api.get('/logout')-->
<!--                    .then(response=>{-->
<!--                        window.location = '/';-->
<!--                        //-->
<!--                    });-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style scoped>-->
<!--    .logo {-->
<!--        max-width: 300px;-->
<!--    }-->
<!--    a.router-link-active {-->
<!--        color: white!important;-->
<!--    }-->
<!--    .content-area{-->
<!--        min-height: calc(100vh - 18rem);-->
<!--    }-->
<!--</style>-->